import {Location} from 'history';
import {ButtonTheme} from 'packages/buttons/button';
import {PrimaryFilled, SecondaryFilled} from 'src/themes/button';

export type MainButton = {
    titleTPath: string;
    link: string;
    theme: ButtonTheme;
};

export function GetMainButtons(location?: Location): MainButton[] {
    if (
        location &&
        ['offices', 'one-day-tours', 'multi-day-tours', 'bicycle-tours'].some(
            path => location.pathname.indexOf(path) !== -1
        )
    ) {
        return [];
    }

    return [
        {
            titleTPath: 'book',
            link: 'offices',
            theme: PrimaryFilled,
        },
        {
            titleTPath: 'tours',
            link: 'one-day-tours',
            theme: SecondaryFilled,
        },
    ];
}
